import { Button, ArrowLeftIcon, ArrowRightIcon } from '@ag1/ui';
import styles from './styles.module.scss';

type TestimonialsFlyoutArrowsProps = {
  onClickPrev: () => void;
  onClickNext: () => void;
};

const TestimonialsFlyoutArrows = ({ onClickPrev, onClickNext }: TestimonialsFlyoutArrowsProps) => (
  <div className={styles.root}>
    <Button
      className={styles.button}
      icon={<ArrowLeftIcon className={styles.icon} titleAccess="Previous" />}
      aria-label="Prev Slide Button"
      onClick={onClickPrev}
      onlyIcon
    />
    <Button
      className={styles.button}
      icon={<ArrowRightIcon className={styles.icon} titleAccess="Next" color="currentColor" />}
      aria-label="Next Slide Button"
      onClick={onClickNext}
      onlyIcon
    />
  </div>
);

export default TestimonialsFlyoutArrows;
